import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from '~~utils/CommonUtils';
import { TABLET_WIDTH } from '~~elements/Const';

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  .team-header {
    &--pic {
      border-radius: 50%;
      width: 6rem;
      height: 6rem;
      margin-right: 0.5rem;
      object-fit: cover;
    }
    &--name {
      font-size: 1.2rem;
    }
    &--change {
      color: #aaaaaa;
      display: flex;
      align-items: center;
      font-size: 0.8rem;

      select,
      option {
        color: #aaaaaa;
        &:hover,
        &:focus {
          display: inline-block;
        }
      }

      &-hint {
        font-size: 0.8rem;
        margin-left: 3rem;
      }
      select {
        display: none;
      }

      &:hover,
      &:focus {
        select {
          display: inline-block;
        }
      }
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    flex-direction: column;
    text-align: center;
    align-items: center;
    align-self: center;
    .team-header {
      &--change-hint {
        margin-left: 0;
      }
    }
  }
`;

const TeamHeader = ({ teams, teamIndex, setTeamIndex }) => {
  const query = useQuery();
  useEffect(() => {
    const tindex = query.get('tindex');
    const queryTeamIndex = parseInt(tindex);
    if (!tindex || queryTeamIndex === teamIndex) {
      return;
    }

    if (Number.isNaN(queryTeamIndex) || queryTeamIndex < 0 || queryTeamIndex > teams.length - 1) {
      return query.delete('tindex');
    }

    setTeamIndex(queryTeamIndex);
  }, [query, setTeamIndex, teamIndex, teams]);

  const handleLeagueChange = (e) => {
    query.set({ tindex: e.target.value });
  };

  if (teams.length === 0) {
    return <></>;
  }

  return (
    <StyledDiv>
      <img className="team-header--pic" src={teams[teamIndex].info.icon_url} alt="" />
      <div>
        <div className="team-header--name">
          <a
            href={`${process.env.REACT_APP_MAINPAGE_URL}/team/${teams[teamIndex].info.uniqid}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {teams[teamIndex].info.name}
          </a>
        </div>
      </div>
      {teams.length > 1 && (
        <label className="team-header--change" tabIndex="-1">
          <div className="team-header--change-hint">切換</div>
          <select value={teamIndex} onChange={handleLeagueChange}>
            {teams.map((team, index) => (
              <option key={index} value={index}>
                {team.info.name}
              </option>
            ))}
          </select>
        </label>
      )}
    </StyledDiv>
  );
};

export default TeamHeader;
